import React from 'react';

export const baseTrackingData = {};

const TrackingContext = React.createContext(baseTrackingData);

export default TrackingContext;
